import "./App.css";
import React from "react";
import SideNav from './views/sideNavbar';
import MainNavBar from './views/mainPage';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import LoginAsEmployee from "./views/loginAsEmployee";
import LoginAsAdmin from "./views/Admin/sideAdminNavbar";
import { useState, useEffect } from "react";

function App() {
  return (
    <div className="App">
      <BrowserRouter>

        <Routes>
          {/* <Route exact path="/" element={<MainNavBar />} /> */}
          <Route path="/" element={<LoginAsEmployee />} />
          <Route path="/admin" element={<LoginAsAdmin />} />
          <Route path="/KSA-RCM" element={<SideNav  />} />


        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
